import { EntityChip, Tooltip } from '@silverfort/sf-components';

export const TableStringListColumn = ({ list, maxVisible = 1 }: { list: string[]; maxVisible?: number }) => {
    const visibleItems = list.slice(0, maxVisible);
    const hiddenItems = list.slice(maxVisible);

    return (
        <div className="flex items-center gap-1 whitespace-nowrap">
            <div className="flex grow-1">
                {visibleItems.map((item) => (
                    <EntityChip className="h-6" key={item} text={item} />
                ))}
            </div>
            {hiddenItems.length > 0 && (
                <Tooltip
                    placement="top-start"
                    title={
                        <div className="flex flex-col hover:pointer-events-none cursor-default">
                            {hiddenItems.map((n, i) => (
                                <div key={i}>{n}</div>
                            ))}
                        </div>
                    }>
                    <EntityChip className="h-6 overflow-hidden" text={`+${hiddenItems.length}`} />
                </Tooltip>
            )}
        </div>
    );
};
